import { CommonHelper } from '../../../helpers/common-helper'
import { EventsNames } from '../../../helpers/events-names'
import { LocalizationHelper } from '../../../helpers/localization-helper'
import { PopupType } from './../../../helpers/popup-manager'

import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'
import { OpPackage } from '../../../models/core'

import { PackageService } from '../../../services/package'

import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'

export class PackageCreateEditController extends CreateEditController {

    // Members

    private referenceValue: OpPackage

    // Members End


    constructor(
        private $scope: CreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private packageService: PackageService,
        referenctType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenctType)

        this.setEvents()
        this.setOptions()
    }


    // Events

    private onInit(args: any[]) {
        if (args && args[0]) {
            const createEditInitParams: CreateEditInitParams = args[0]

            this.referenceValue = createEditInitParams ? <OpPackage>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)

            if (this.referenceValue && this.referenceValue.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }

    private onInitBulk(args: any[]) {
        if (args && args[0]) {
            const bulkEditInitParams: BulkEditInitParams = args[0]

            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)

            if (args && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onSave(objectToSave: IOpObject): ng.IPromise<OpPackage> {
        const deferred = this.$q.defer<OpPackage>()
        const packageToSave: OpPackage = this.packageService.createOpPackageFromIOpObject(objectToSave, this.referenceValue)

        this.packageService
            .savePackage(packageToSave)
            .then((savedObject: OpPackage) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                deferred.reject(error)
            })

        return deferred.promise
    }

    private onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred = this.$q.defer<IOpObject>()

        // ReportHelper
        //     .saveReport(this.userSession.getDataProvider(), OpPackage.fromIOpObject(objectToSave))
        //     .then((savedObject: OpPackage) => {
        //         deferred.resolve(savedObject)
        //     })
        //     .fail((error: any) => {
        //         this.logger.log(error)
        //         deferred.reject(error)
        //     })

        return deferred.promise
    }

    // Events End


    // Setup 

    private setEvents() {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    private setOptions() {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: '',
            type: null,
            referenceType: this.referenceType,
            onClose: null,
            onSubmit: null,
            submitBulkEdit: null,
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.packageSaved,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),

            onBulkSave: (objectToSave: IOpObject) => null,//this.onBulkSave(objectToSave),
            onSave: (objectToSave: IOpObject) => this.onSave(objectToSave),
        }
    }

    // Setup End
}